import {
  BrandSelectionWidget,
  ProductCategorySelectionWidget,
  ProductUnitSelectionWidget,
} from 'components/FormWidget';

const uiSchema = () => ({
  category_id: {
    'ui:widget': ProductCategorySelectionWidget,
  },
  brand_id: {
    'ui:widget': BrandSelectionWidget,
  },
  unit_id: {
    'ui:widget': ProductUnitSelectionWidget,
  },
  weight: {
    'ui:options': {
      xs: 12,
      sm: 12,
      md: 6,
      lg: 6,
      xl: 6,
    },
  },
  num_in_box: {
    'ui:options': {
      xs: 12,
      sm: 12,
      md: 6,
      lg: 6,
      xl: 6,
    },
  },
});

export default uiSchema;
